import { ENV } from "app_constants";

const TRACK_JS_TOKEN = "fd970d226c4b475d897759f950989046";

const TRACK_JS_CONFIG = {
  staging: "staging-all",
  production: "hq3-prod",
};

const TRACK_JS_APPLICATION_KEY =
  TRACK_JS_CONFIG[ENV as keyof typeof TRACK_JS_CONFIG];

export { TRACK_JS_APPLICATION_KEY, TRACK_JS_TOKEN };
